module.exports = __webpack_public_path__ + "static/media/footsteps.b1c1ae92.mp3";